/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Welcome_Title_ShortInputs */



/**
* | output |
* | --- |
* | "Good to have you here." |
*
* @param {Onboarding_Welcome_Title_ShortInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_title_short = /** @type {((inputs?: Onboarding_Welcome_Title_ShortInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_Title_ShortInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Fijn dat je er bent.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ravi de vous accueillir.")
	return /** @type {LocalizedString} */ ("Good to have you here.")
});